export { default as InternalViewBadge } from './InternalViewBadge';
